<div class="content-full message release-view">
    <kno2-message-action-bar
        [message]="message"
        [deliverySummaryEnableDownload]="deliverySummaryEnableDownload()"
        [readonly]="true" />
    <div class="row">
        <div class="col-sm-9 col-lg-8 col-xl-8 col-no-padding auto-fill">
            <div class="header pt-2">
                @for (notification of notifications(); track $index) {
                    <div class="alert alert-info mb-2">
                        {{ notification }}
                    </div>
                }

                <div class="details">
                    <div class="row">
                        <div class="col-sm-10 col-sm-9 col-md-8 col-lg-7">
                            <div class="msg-title">
                                {{ message.subject }}
                            </div>
                        </div>
                        <div class="msg-date col-sm-2 col-sm-3 col-md-4 col-lg-5">
                            <span>{{ message.messageDate | localDate: "MMM d, y h:mm a" }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <ul
                                class="list-unstyled"
                                style="margin-bottom: 0">
                                <li>
                                    @if (message.fromAddress) {
                                        <div class="msg-from">
                                            <div class="label intake-message-label col-sm-1 col-md-1 pad0 mt-0">From:</div>
                                            <span
                                                class="intake-doc k2-ellipsis col-sm-11 pad0"
                                                style="display: inline-block">
                                                <kno2-multi-address-snippet [addressString]="message.fromAddress" />
                                            </span>
                                        </div>
                                    }
                                </li>
                                <li>
                                    @if (message.toAddress) {
                                        <div class="msg-to">
                                            <div class="label intake-message-label col-sm-1 col-md-1 pad0 mt-0">To:</div>
                                            <span class="intake-doc k2-ellipsis col-sm-11 col-md-10 pad0">
                                                <kno2-multi-address-snippet [addressString]="message.toAddress || []" />
                                            </span>
                                        </div>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="doc-viewer"
                id="doc-viewer">
                <kno2-pdf-viewer-container
                    [attachment]="selectedAttachment()"
                    [options]="viewerOptions()"
                    (attachmentRead)="onAttachmentRead($event)" />

                <div class="doc-container">
                    <h2>Message Body</h2>
                    <div class="doc-from">{{ message.fromAddress }}</div>
                    <div class="doc-date">{{ message.messageDate | localDate: "MMM d, y 'at' h:mm a" }}</div>
                    <div class="doc-body">
                        <div [innerHTML]="message.body | replace: ['\n', '\<br>']"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-3 col-lg-4 col-xl-4 auto-fill intake-right-border col-no-gutters">
            <kno2-message-patient-details
                [showPatientLookup]="false"
                [showVisitLookup]="false"
                [showVisitDetails]="false" />
            <kno2-message-patient-attachments
                [(attachments)]="message.attachments"
                [(selectedAttachment)]="selectedAttachment"
                [documentTypes]="documentTypes()"
                [showAddAttachment]="false"
                [showRenameAttachment]="false"
                [showDeleteAttachment]="false"
                [showOrderLookup]="false" />
        </div>
    </div>
</div>
